import {  IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class SaleOrderIdsRequest {
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number[];
    @ApiProperty()
    plantId?: number;
}